export default __webpack_public_path__ + "static/media/i016hp.dad5d62d.webp";